import { EntityTypeEnum } from './Enumerables';

// Permission mapping
export const PERMISSIONS = {
  [EntityTypeEnum.Pipelines]: {
    VIEW: 1,
    CREATE: 2,
    EDIT: 4,
    DELETE: 8
  },
  [EntityTypeEnum.Task]: {
    VIEW: 1,
    CREATE: 2,
    EDIT: 4,
    DELETE: 8
  },
  [EntityTypeEnum.User]: {
    VIEW: 1,
    CREATE: 2,
    EDIT: 4,
    DELETE: 8
  },
  [EntityTypeEnum.Trace]: {
    VIEW: 1,
    CREATE: 2,
    EDIT: 4,
    DELETE: 8
  },
  [EntityTypeEnum.Search]: {
    VIEW: 1,
    CREATE: 2,
    EDIT: 4,
    DELETE: 8
  },
  [EntityTypeEnum.Pension]: {
    VIEW: 1,
    CREATE: 2,
    EDIT: 4,
    DELETE: 8
  },
  [EntityTypeEnum.Company]: {
    VIEW: 1,
    CREATE: 2,
    EDIT: 4,
    DELETE: 8
  },
  [EntityTypeEnum.Provider]: {
    VIEW: 1,
    CREATE: 2,
    EDIT: 4,
    DELETE: 8
  },
  [EntityTypeEnum.Scheme]: {
    VIEW: 1,
    CREATE: 2,
    EDIT: 4,
    DELETE: 8
  },
  [EntityTypeEnum.Document]: {
    VIEW: 1,
    CREATE: 2,
    EDIT: 4,
    DELETE: 8
  },
  [EntityTypeEnum.Automations]: {
    VIEW: 1,
    CREATE: 2,
    EDIT: 4,
    DELETE: 8
  },
  [EntityTypeEnum.Guides]: {
    CREATE: 1,
    EDIT: 2,
    DELETE: 4
  },
  [EntityTypeEnum.GuideCategories]: {
    CREATE: 1,
    EDIT: 2,
    DELETE: 4
  },
  [EntityTypeEnum.Settings]: {
    VIEW_GLOBALS: 1,
    EDIT_GLOBALS: 2,
    VIEW_TEAMS: 4,
    CREATE_TEAMS: 8,
    EDIT_TEAMS: 16,
    DELETE_TEAMS: 32,
    VIEW_ROLES: 64,
    CREATE_ROLES: 128,
    EDIT_ROLES: 256,
    DELETE_ROLES: 512,
    VIEW_TAGS: 1024,
    CREATE_TAGS: 2048,
    EDIT_TAGS: 4096,
    DELETE_TAGS: 8192,
    VIEW_API: 16384,
    CREATE_API_KEYS: 32768,
    DELETE_API_KEYS: 65536,
    VIEW_STATUSES: 131072,
    CREATE_STATUSES: 262144,
    EDIT_STATUSES: 524288,
    DELETE_STATUSES: 1048576,
    // TEAM_STATS_ROLE_V1: the dashboard's Team section and the header's Team Profile links
    VIEW_TEAM_STATS: 2097152,
    // AUDIENCE_SWITCH_V1: the top bar's Assisted / Portal / Guide / All switch (was Admin role only)
    VIEW_AUDIENCE_SWITCH: 4194304,
    // ROLE_PAGES_V1: the home dashboard ('/' and '/v2')
    VIEW_DASHBOARD: 8388608
  },
  [EntityTypeEnum.Lead]: {
    VIEW: 1,
    CREATE: 2,
    EDIT: 4,
    DELETE: 8
  },
  [EntityTypeEnum.AiTableView]: {
    // ROLE_PAGES_V1: the +Ai Tables area (sidebar item and /ai-tables pages)
    VIEW: 1,
    CREATE: 2,
    EDIT: 4,
    DELETE: 8
  }
};

// Can this profile open an entity's page? Entities without a VIEW permission are open to all.
export const canView = (profile, entityType) =>
  !PERMISSIONS[entityType]?.VIEW ||
  !!profile?.hasPermission?.(entityType, PERMISSIONS[entityType].VIEW);

export const canSeeDashboard = profile =>
  !!profile?.hasPermission?.(
    EntityTypeEnum.Settings,
    PERMISSIONS[EntityTypeEnum.Settings].VIEW_DASHBOARD
  );
